import { render, staticRenderFns } from "./descriptionBulkPurchases.vue?vue&type=template&id=2061c999&scoped=true&"
import script from "./descriptionBulkPurchases.vue?vue&type=script&lang=js&"
export * from "./descriptionBulkPurchases.vue?vue&type=script&lang=js&"
import style0 from "./descriptionBulkPurchases.vue?vue&type=style&index=0&id=2061c999&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2061c999",
  null
  
)

export default component.exports